import * as ActionTypes from '../constants';
import { baseUrl } from '../';
import axios from 'axios';
import { getUserToken } from './../getUserToken';

export default function(state={}, action) {
    switch(action.type) {
        case ActionTypes.REQUEST_GET_ALL_TESTS: 
            return {
                ...state,
                loading: true,
                error:false,
                errInfo: null
            }
        case ActionTypes.RECEIVED_GET_ALL_TESTS: 
            return {
                ...state,
                loading: false,
                response: action.res,              
                error: false,
                errInfo: null
            }
        case ActionTypes.ERROR_GET_ALL_TESTS:
            return {
                ...state,
                loading: false,
                error: true,
                errInfo: action.err
            }
        case ActionTypes.CLEAR_GET_ALL_TESTS:
            return { }
        default :  return state
    }
}

const dispatchRequestAllTests = () => ({
    type: ActionTypes.REQUEST_GET_ALL_TESTS
})

const dispatchReceivedAllTests = res => ({
    type: ActionTypes.RECEIVED_GET_ALL_TESTS,
    res
})

const dispatchErrorAllTests = err => ({
    type: ActionTypes.ERROR_GET_ALL_TESTS,
    err
})

const dispatchClearAllTests = () => ({
    type: ActionTypes.CLEAR_GET_ALL_TESTS
})

export const clearAllTestsData = () => dispatchClearAllTests();


export const getAllTestsInfo = () => dispatch => { 
    getUserToken()
        .then(token => {
            dispatch(dispatchRequestAllTests(token));       
            const options = {
                method: 'post',
                url: `${baseUrl}/api/mytests`,                 
                headers: {
                    Authorization: `Bearer ${token}`
                }
            }         
            return axios(options).then( ({data}) => {
                dispatch(dispatchReceivedAllTests(data));
            })            
        }) 
        .catch(e => dispatch(dispatchErrorAllTests(e.response)));
}